// import { OETrans } from 'components/translation/OETrans';
import { CompanyUserType } from 'lib/api_ts/companiesApi';
import {
	DeliverableType,
	getDeliverablesByProjectId,
	getMilestonesByProjectId,
	getTasksByProjectIdStreamId,
	MilestoneType,
	StreamType,
	TaskType,
} from 'lib/api_ts/overviewApi';
import React, { useEffect, useState } from 'react';
import Gantt from './Gantt';
import { getOeTaskStatus } from 'lib/api';
import { Loading } from '@components/atomic/atoms';
// import { Gantt } from "wx-react-gantt";
// import "wx-react-gantt/dist/gantt.css";

interface OverviewProps {
	activeKey: string;
	projectId: number;
	streams?: StreamType[];
	users?: CompanyUserType[];
}

export type TaskStatusMapType = {
	code: string;
	name: string;
	description: string | null;
}[];

const Overview: React.FC<OverviewProps> = ({ activeKey, projectId, streams = [], users = [] }) => {
	const [isLoading, setIsLoading] = useState(true);
	const [milestones, setMilestones] = useState<MilestoneType[]>([]);
	const [deliverables, setDeliverables] = useState<DeliverableType[]>([]);
	// console.log("streams", streams);
	const [tasks, setTasks] = useState<TaskType[]>([]);

	const [taskStatusMap, setTaskStatusMap] = useState<TaskStatusMapType>([]);
	useEffect(() => {
		// if (streams.length === 0) return;
		// console.log("streams", streams);
		(async () => {
			try {
				const milestonesPromise = getMilestonesByProjectId(projectId.toString());
				const deliverablesPromise = getDeliverablesByProjectId(projectId.toString());

				const taskStatusMapPromise: Promise<{ data: TaskStatusMapType }> = getOeTaskStatus();

				const tasksPromises = streams.length
					? streams.map((stream) => getTasksByProjectIdStreamId(projectId.toString(), stream.id.toString()))
					: [];

				const [milestones, deliverables, taskStatusMap, ...tasks] = await Promise.all([
					milestonesPromise,
					deliverablesPromise,
					taskStatusMapPromise,
					...tasksPromises,
				]);

				setMilestones(milestones);
				setDeliverables(deliverables);
				setTaskStatusMap(taskStatusMap.data);
				if (streams.length) {
					setTasks(tasks.flat());
					setIsLoading(false);
				}
			} catch (error) {
				console.error('Error fetching data', error);
			}
		})();
	}, [projectId, streams]);
	// console.log("milestones", milestones);
	// console.log("deliverables", deliverables);
	// console.log("tasks", tasks);
	// console.log('taskStatusMap', taskStatusMap);

	return isLoading ? (
		<Loading fixedHeight="50vh" />
	) : (
		<Gantt
			activeKey={activeKey}
			milestones={milestones}
			deliverables={deliverables}
			tasks={tasks}
			users={users}
			streams={streams}
			taskStatusMap={taskStatusMap}
		/>
	);
};

export default Overview;
